/* eslint import/prefer-default-export: 0 */

export const UPDATE_ACTIVE_TAB = 'UPDATE_ACTIVE_TAB';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const UPDATE_MAIN_QUERY = 'UPDATE_MAIN_QUERY';
export const UPDATE_ARTWORKS = 'UPDATE_ARTWORKS';
export const UPDATE_ORDER = 'UPDATE_ORDER';
export const ADD_REPORTED_TO_BID = 'ADD_REPORTED_TO_BID';
export const UPDATE_CURRENT_ARTWORK_INDEX = 'UPDATE_CURRENT_ARTWORK_INDEX';
export const UPDATE_META = 'UPDATE_META';
export const UPDATE_ARTWORKS_CATEGORIES = 'UPDATE_ARTWORKS_CATEGORIES';
export const CLEAR_ARTWORKS_FILTERS = 'CLEAR_ARTWORKS_FILTERS';
export const INITIALIZE_ARTWORKS_FILTERS = 'INITIALIZE_ARTWORKS_FILTERS';
export const UPDATE_TOO_MANY_RESULTS = 'UPDATE_TOO_MANY_RESULTS';
export const UPDATE_SORTING = 'UPDATE_SORTING';
export const CLEAR_ARTWORKS_STATE_FILTERS = 'CLEAR_ARTWORKS_STATE_FILTERS';
export const CLEAR_TOTAL_COUNT = 'CLEAR_TOTAL_COUNT';
export const SET_CURRENT_USER_ID = 'SET_CURRENT_USER_ID';
export const SET_MEMORISE_STATE = 'SET_MEMORISE_STATE';



// WEBPACK FOOTER //
// ./app/javascript/packs/search_page/index/store/mutation-types.js